export default __webpack_public_path__ + "static/media/calendar.6148ce08.svg";